// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"65":"19eb5b1f","84":"36b1e53a","147":"0711a264","362":"fa36252f","536":"7b551b2d","604":"af28d630","807":"7d92bbe9","900":"a8d08fcf","996":"3537362b"}[chunkId] + ".chunk.js";
};